'use client';
import { Container } from '@/components/container';
import { Button } from '@/components/ui/button';
import { IDEA_STARTER_TILES } from '@/lib/idea-starter-tile-mapping';
import { useAuthStore } from '@/store';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React from 'react';

export const IdeaStarterBanner = () => {
  const { user } = useAuthStore();

  const router = useRouter();

  return (
    <div className="bg-ihs-gray">
      <Container>
        <div className="py-8 flex flex-col gap-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <h2 className="font-bold text-xl">Idea Starter</h2>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2">
            {IDEA_STARTER_TILES.map((tile) => (
              <Link
                key={tile.slug}
                href={`/idea-starters?starter=${tile.slug}`}
                className="bg-white p-4 rounded-md shadow-sm text-center text-sm font-medium text-[#24292E] hover:bg-ihs-gray/40 hover:shadow transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ihs-dark-blue focus-visible:ring-offset-2"
              >
                {tile.label}
              </Link>
            ))}
          </div>

          <div className="flex flex-col gap-4 items-center">
            <div className="flex lg:flex-row w-full flex-col items-center justify-center gap-2">
              <Button
                variant="outline"
                onClick={() => router.push('/idea-starters')}
                className="border-ihs-dark-blue w-full lg:w-auto text-ihs-dark-blue hover:text-ihs-dark-blue uppercase font-bold p-6"
              >
                Explore stories
              </Button>

              {!user && (
                <Link href="/discover-more">
                  <Button
                    variant="outline"
                    className="border-ihs-dark-blue w-full lg:w-auto text-ihs-dark-blue hover:text-ihs-dark-blue uppercase font-bold p-6"
                  >
                    Join the community
                  </Button>
                </Link>
              )}
            </div>

            {/* {!user && (
              <div className="flex lg:flex-row flex-col w-full justify-center items-center gap-4">
                <p className="text-sm ">Register to unlock stories</p>
                <Link href="/sign-up">
                  <Button
                    variant="default"
                    className="bg-ihs-dark-blue w-full lg:w-auto uppercase hover:bg-ihs-dark-blue/90 font-bold p-6"
                  >
                    Register now
                  </Button>
                </Link>
              </div>
            )} */}
          </div>
        </div>
      </Container>
    </div>
  );
};
